import * as React from 'react';
import { type Theme, useStyletron } from 'baseui';
import { QuestionMarkIcon } from '../../../../../common/review-mode-side-panel/icons/question-mark-icon';
import { KEYPOINTS_PANEL } from '../../../constants/template-builder';
const getContainerStyles = (theme: Theme) => ({
  display: ('flex' as const),
  flexDirection: ('column' as const),
  alignItems: ('center' as const),
  justifyContent: ('center' as const),
  alignSelf: ('stretch' as const),
  flexGrow: 1,
  padding: theme.sizing.scale1200
});
const getTitleStyles = (theme: Theme) => ({
  ...theme.typography.HeadingXSmall,
  marginTop: theme.sizing.scale300,
  marginBottom: '0',
  textAlign: ('center' as const)
});
const getDescriptionStyles = (theme: Theme) => ({
  ...theme.typography.ParagraphMedium,
  marginTop: theme.sizing.scale100,
  marginBottom: '0',
  textAlign: ('center' as const),
  color: theme.colors.contentPrimary
});
export function KeypointsEmptyState() {
  const [css, theme] = useStyletron();
  return <div className={css(getContainerStyles(theme))} data-testid="keypoints-empty-state">
      <QuestionMarkIcon />
      <div className={css(getTitleStyles(theme))}>{KEYPOINTS_PANEL.EMPTY_TITLE}</div>
      <div className={css(getDescriptionStyles(theme))}>{KEYPOINTS_PANEL.EMPTY_DESCRIPTION}</div>
    </div>;
}